import styled from '@emotion/styled'
import { TCards } from '@lbs/shared-rp-types'
import { forwardRef, HTMLAttributes } from 'react'

type CardProps = HTMLAttributes<HTMLDivElement> & {
  value: TCards | null
  className?: string
  children?: React.ReactNode
}

const Img = styled.img`
  display: block;
`

const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ value, className, children, ...rest }, ref) => {
    const url =
      value !== null ? `${process.env.PUBLIC_URL}/cards/${value}.svg` : ''

    return (
      <div className={className} ref={ref} {...rest}>
        {value && <Img src={url} alt={value} />}
        {children}
      </div>
    )
  }
)

Card.displayName = 'Card'

export default Card
